'use client'

import { useState } from 'react'
import { Button } from './ui/button'
import { Input } from './ui/input'
import { useActions, useUIState } from 'ai/rsc'
import type { AI } from '@/app/action'
import { UserMessage } from './user-message'
import { ArrowRight } from 'lucide-react'
import { PiMagnifyingGlassThin } from 'react-icons/pi'
import { LoginDialog } from './ui/login-dialog'
import { useSession } from 'next-auth/react'
import { canAskQuestions } from '@/app/lib/auth-limit'
import { useSubdomain } from '@/hooks/useSubdomain'

export function FollowupPanel() {
  const session = useSession()
  const subdomain = useSubdomain()

  const [isOpenLoginDialog, setIsOpenLoginDialog] = useState(false)
  const [input, setInput] = useState('')
  const { submit } = useActions()
  const [, setMessages] = useUIState<typeof AI>()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget as HTMLFormElement)

    const userMessage = {
      id: Date.now(),
      isGenerating: false,
      component: <UserMessage message={input} isFirstMessage={false} />
    }

    const canAsk = await canAskQuestions({
      sessionStatus: session.status,
      subdomain
    })

    if (!canAsk) {
      setIsOpenLoginDialog(true)
      return
    }

    const responseMessage = await submit(formData)
    setMessages(currentMessages => [
      ...currentMessages,
      userMessage,
      responseMessage
    ])

    setInput('')
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="sticky bottom-24">
        <div className="relative">
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            type="text"
            name="input"
            placeholder="Ask a follow-up question..."
            className="leading-5 resize-none max-h-60 pl-8 sm:pl-10 pr-14  rounded-full hover:shadow-lg hover focus-visible:shadow-lg flex  w-full border border-input py-3 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring  disabled:cursor-not-allowed disabled:opacity-50"
          />
          <div className="absolute left-3 text-xl top-1/2 transform  -translate-y-1/2">
            <PiMagnifyingGlassThin />
          </div>
        </div>
      </form>
      <LoginDialog
        open={isOpenLoginDialog}
        handleClose={() => setIsOpenLoginDialog(false)}
      />
    </>
  )
}
